<template>
  <v-app id="eign1">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>
      <v-row>    
          <v-col cols="5">
            <v-select v-model="ctrlCodesSelected" :items="ctrlCodes" item-value="ctrl_nr"  item-text="ctrl_oms" label="Roles" multiple></v-select>
          </v-col>
      </v-row>
      
      <v-row>    
          <v-col cols="5">
            <v-select v-model="statCodesSelected" :items="statCodes" item-value="statCode"  item-text="statCode" label="Accommodation Status" multiple></v-select>
          </v-col>
      </v-row>

      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="ovrz">Create excel</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      ctrlCodesSelected: [],
      ctrlCodes: [],
      bedrCodesSelected: [],
      bedrCodes: [],
      statCodesSelected: [],
      statCodes: [],
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/exact/getEign1Param.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getEign1Param"
        },
        getEign1Param: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getEign1Param;
           res.data.getEign1Param.ctrl_nrKeuzes.forEach(function(ctrl) {
           deze.ctrlCodes.push(ctrl);
            if (ctrl.ctrl_nrSelected === true) {
               deze.ctrlCodesSelected.push(ctrl.ctrl_nr);
            } 
           });
           res.data.getEign1Param.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getEign1Param.statKeuzes.forEach(function(stat) {
             deze.statCodes.push(stat.statCode);
             if (stat.statSelected === true) {
                deze.statCodesSelected.push(stat.statCode);
             }
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/fin/exact/excelExportEign1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportEign1"
          },
          excelExportEign1: {
            ctrl_nrs: this.ctrlCodesSelected,
            bedr_codes: this.bedrCodesSelected,
            stat_codes: this.statCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.excelExportEign1.text,
              color: res.data.excelExportEign1.color,
            });
          //}
          //  this.items = res.data.excelExportEign1;
          //  window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
